import Layout from "@/views/main/Main.vue";
import type { RouteRecordRaw } from "vue-router";
const invoicesRouter: RouteRecordRaw = {
  path: "/invoices",
  component: Layout,
  redirect: "noredirect",
  meta: {
    icon: "el-icon-tickets",
    title: "单据管理"
  },
  children: [
    {
      path: '/invoices/entry',
      component: () => import("@/views/main/invoices/entry/entry.vue"),
      name: 'entry',
      meta: {
        title: '组盘入库'
      }
    },
    {
      path: '/invoices/delivery',
      component: () => import("@/views/main/invoices/delivery/delivery.vue"),
      name: 'delivery',
      meta: {
        title: '单据出库'
      }
    },
    {
      path: '/invoices/StockTransfer',
      component: () => import("@/views/main/invoices/StockTransfer/StockTransfer.vue"),
      name: 'StockTransfer',
      meta: {
        title: '调拨单'
      }
    },
    {
      path: '/invoices/purchase',
      component: () => import("@/views/main/invoices/purchase/purchase.vue"),
      name: 'purchase',
      meta: {
        title: '采购订单'
      }
    },
    {
      path: '/invoices/deliverySearch',
      component: () => import("@/views/main/invoices/deliverySearch/deliverySearch.vue"),
      name: 'deliverySearch',
      meta: {
        title: '采购统计'
      }
    },    
    {
      path: '/invoices/purchaseType',
      component: () => import("@/views/main/invoices/purchaseType/purchaseType.vue"),
      name: 'purchaseType',
      meta: {
        title: '采购类型'
      }
    },   
    {
      path: '/invoices/blackInventoryQuery',
      component: () => import("@/views/main/invoices/blackInventoryQuery/blackInventoryQuery.vue"),
      name: 'blackInventoryQuery',
      meta: {
        title: '黑库调拨查询'
      }
    },        
    {
      path: '/invoices/purchaseOrder',
      component: () => import("@/views/main/invoices/purchaseOrder/purchaseOrder.vue"),
      name: 'purchaseOrder',
      meta: {
        title: '进货单据'
      }
    },
    {
      path: '/invoices/returnOrder',
      component: () => import("@/views/main/invoices/returnOrder/returnOrder.vue"),
      name: 'returnOrder',
      meta: {
        title: '退货单据'
      }
    },    
    {
      path: '/invoices/sortingManagement',
      component: () => import("@/views/main/invoices/sortingManagement/sortingManagement.vue"),
      name: 'sortingManagement',
      meta: {
        title: '分拣管理'
      }
    },
    {
      path: '/invoices/callagvtask',
      component: () => import("@/views/main/invoices/callagvtask/callagvtask.vue"),
      name: 'callagvtask',
      meta: {
        title: 'AGV任务'
      }
    }
  ]
};

//单据管理
export default invoicesRouter;